/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockchainResponseAdminDto } from '../../models/blockchain-response-admin-dto';
import { CreateBlockchainDto } from '../../models/create-blockchain-dto';

export interface AdminBlockchainsControllerCreateBlockchainV1$Params {
      body: CreateBlockchainDto
}

export function adminBlockchainsControllerCreateBlockchainV1(http: HttpClient, rootUrl: string, params: AdminBlockchainsControllerCreateBlockchainV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockchainResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminBlockchainsControllerCreateBlockchainV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlockchainResponseAdminDto>;
    })
  );
}

adminBlockchainsControllerCreateBlockchainV1.PATH = '/v1/admin/blockchains';
